"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageValidationWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PageValidationMessage_1 = require("../helpers/PageValidationMessage");
var PageValidationWidget = /** @class */ (function (_super) {
    __extends(PageValidationWidget, _super);
    function PageValidationWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }
    PageValidationWidget.prototype.render = function () {
        var journeyState = this.props.engine.getJourneyState();
        var hidePageValidationMessage = journeyState["hidePageValidationErrorMessage"] || false;
        var bottomText = this.getErrorMessage();
        var topText = this.getSetting("topText") ? this.getSetting("topText") : "Oops! Something went wrong.";
        if (bottomText && !hidePageValidationMessage) {
            return ((0, jsx_runtime_1.jsx)(PageValidationMessage_1.PageValidationMessage, { topText: topText, bottomText: bottomText, handleCloseFunction: this.handleClose }));
        }
        else {
            return null;
        }
    };
    PageValidationWidget.prototype.getErrorMessage = function () {
        var showQuestionValidationMessage = this.getSetting("showQuestionValidationMessage") || false;
        if (this.props.pageValidations) {
            for (var _i = 0, _a = this.props.pageValidations; _i < _a.length; _i++) {
                var validation = _a[_i];
                if (validation.valid === false && validation.errorMessage) {
                    return validation.errorMessage;
                }
            }
        }
        if (this.props.validations) {
            for (var _b = 0, _c = Object.keys(this.props.validations); _b < _c.length; _b++) {
                var questionName = _c[_b];
                var validationResult = this.props.validations[questionName];
                if (validationResult.errors && validationResult.errors.length > 0) {
                    return showQuestionValidationMessage ? validationResult.errors : this.getSetting("bottomText") || "Please try again.";
                }
            }
        }
        return null;
    };
    PageValidationWidget.prototype.handleClose = function () {
        var _a;
        this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = true, _a));
    };
    return PageValidationWidget;
}(plugin_journey_1.WidgetBase));
exports.PageValidationWidget = PageValidationWidget;
//# sourceMappingURL=PageValidationWidget.js.map